import * as React from 'react';

import { FilterIcon } from '@coursera/cds-icons';

import ChipButton from 'bundles/search-common/components/experiments/filters2024/ChipButton';

import _t from 'i18n!nls/search-common';

type Props = {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  showLabel?: boolean;
  numActiveFilters?: number;
};

const FiltersButton = ({ onClick, showLabel = true, numActiveFilters = 0 }: Props) => {
  return (
    <ChipButton
      onClick={onClick}
      prefix={<FilterIcon />}
      count={numActiveFilters}
      showCount={numActiveFilters > 0}
      showLabel={showLabel}
    >
      {_t('Filter & Sort')}
    </ChipButton>
  );
};

export default FiltersButton;
